import { registerFaviconProvider } from 'owa-favicon';
import mailFaviconProvider from './mailFaviconProvider';
// Initialize orchestrators
import '../orchestrators/onFolderSelectedOrchestrator';
import '../orchestrators/onNewMessageOrchestrator';
import '../orchestrators/onPageVisibilityChanged';
export default function initializeMailFavicon() {
    registerFaviconProvider(mailFaviconProvider);
}
//# sourceMappingURL=initializeMailFavicon.js.map